(function (analytics) {
    "use strict";

    analytics.plugins = analytics.plugins || [];

    analytics.plugins.push(function () {
        /*
         * Audience Manager Integration
         * #MTKRK-1979
         */
        s.AudienceManagement.setup({
             "partner": "iggroup",
              "containerNSID": 0,
              "uuidCookie": {
                  "name":"aam_uuid",
                  "days":30
              }
        });
    });
})(window.nadex.marketing.analytics);